
<div>
  <slot></slot>
  <!--    Change <property> to <value>, <property> to <value>, and <property> to <value> when <condition>-->
  {{propertyUpdatesDescription(objectModelTrigger.propertyUpdatesArray)}}
</div>
